import React from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import { FormattedMessage } from "react-intl";
import { handleBlankValue } from "../../../commons/CommonUtils";
import Box from "@amzn/meridian/box";

const OtherAttributes = (props) => {
    if (!props.data) {
        return null;
    }

    let packageDimensions = props.data.packageDimensions;
    let packageLength = packageDimensions && packageDimensions.packageLength && packageDimensions.packageLength.value ? packageDimensions.packageLength.value.toFixed(2) : null;
    let packageLengthUnit = packageDimensions && packageDimensions.packageLength && packageDimensions.packageLength.unit ? packageDimensions.packageLength.unit.toLowerCase() : null;
    let packageWidth = packageDimensions && packageDimensions.packageWidth && packageDimensions.packageWidth.value ? packageDimensions.packageWidth.value.toFixed(2) : null;
    let packageWidthUnit = packageDimensions && packageDimensions.packageWidth && packageDimensions.packageWidth.unit ? packageDimensions.packageWidth.unit.toLowerCase() : null;
    let packageHeight = packageDimensions && packageDimensions.packageHeight && packageDimensions.packageHeight.value ? packageDimensions.packageHeight.value.toFixed(2) : null;
    let packageHeightUnit = packageDimensions && packageDimensions.packageHeight && packageDimensions.packageHeight.unit ? packageDimensions.packageHeight.unit.toLowerCase() : null;
    let dimensionValue = packageLength + " " + packageLengthUnit + " x " + packageWidth + " " + packageWidthUnit + " x " + packageHeight + " " + packageHeightUnit;

    let packageWeight = packageDimensions && packageDimensions.packageWeight && packageDimensions.packageWeight.value ? packageDimensions.packageWeight.value.toFixed(2) : null;
    let packageWeightUnit = packageDimensions && packageDimensions.packageWeight && packageDimensions.packageWeight.unit ? packageDimensions.packageWeight.unit.toLowerCase() : null;

    const listToStringWithDefault = (str) => {
        if (str == null || str.length === 0)
            return 'Standard';
        else
            str = str.join(",");
        return str
    }
    return (
        <Column>
            <Row widths={["grid-3"]} spacingInset="medium large none">
                <Text type="h300"><FormattedMessage id="search.package.otherAttributes_boxInfo" defaultMessage="Box Info"/></Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.otherAttributes_dimensions" defaultMessage="Dimensions (L x W x H)"/></Text>
                <Text type="b200">{handleBlankValue(dimensionValue)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.otherAttributes_weight" defaultMessage="Weight"/></Text>
                <Text type="b200">{handleBlankValue(packageWeight && packageWeightUnit ? packageWeight + ' ' + packageWeightUnit : null)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="medium large none">
                <Text type="h300"><FormattedMessage id="search.package.otherAttributes_additionalAttributes" defaultMessage="Additional Attributes"/></Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="medium large none">
                <Text type="h100"><FormattedMessage id="search.package.otherAttributes_deliveryTypes" defaultMessage="Delivery Type"/></Text>
                <Text type="b200">{listToStringWithDefault(props.data.deliveryTypes)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.otherAttributes_hazmat" defaultMessage="Hazmat"/></Text>
                <Text type="b200">
                    {handleBlankValue(props.data.isHazmat === true ?
                        <FormattedMessage id="search.package.otherAttributes_yes" defaultMessage="Yes"/>
                        : props.data.isHazmat === false ?
                            <FormattedMessage id="search.package.otherAttributes_no" defaultMessage="No"/>
                            : '')}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.otherAttributes_avd"
                                                    defaultMessage="Age verified delivery"/></Text>
                <Text type="b200">
                    {handleBlankValue(props.data.isAvdPackage === true ?
                        <FormattedMessage id="search.package.otherAttributes_yes" defaultMessage="Yes"/>
                        : props.data.isAvdPackage === false ?
                            <FormattedMessage id="search.package.otherAttributes_no" defaultMessage="No"/>
                            : '')}</Text>
            </Row>
            { props.data.shipmentCategory &&
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.otherAttributes_shipmentCategory"
                                                    defaultMessage="Shipment Category"/></Text>
                <Text type="b200">{handleBlankValue(props.data.shipmentCategory)}</Text>
            </Row>}
            { props.data.salColor &&
                <Row widths={["grid-3"]} spacingInset="xsmall large">
                    <Text type="h100"><FormattedMessage id="search.package.otherAttributes_salColor"
                                                        defaultMessage="SAL Color"/></Text>
                    <Box backgroundColor={props.data.salColor} type="outline" spacingInset="medium large medium medium"></Box>
                </Row>
            }
        </Column>

    )            
}

export default OtherAttributes;


// WEBPACK FOOTER //
// ./src/components/detailPages/packageDetails/OtherAttributes.js